import { createReducer, on } from '@ngrx/store';
import {
  clearDriverManagementDrivers,
  clearDriverManagementDriversByKey,
  loadDriverManagementDrivers,
  loadDriverManagementDriversFailure,
  loadDriverManagementDriversSuccess,
} from './driver-management-drivers.actions';
import { DriverManagementDriversResponse } from './driver-management-drivers.models';

export interface DriverManagementDriversState {
  cache: { [key: string]: DriverManagementDriversResponse };
  loading: { [key: string]: boolean };
  error: { [key: string]: string | null };
}

export const initialState: DriverManagementDriversState = {
  cache: {},
  loading: {},
  error: {},
};

export const driverManagementDriversReducer = createReducer(
  initialState,
  on(loadDriverManagementDrivers, (state, { key }) => {
    const isCached = key in state.cache;

    return {
      ...state,
      loading: { ...state.loading, [key]: !isCached },
      error: { ...state.error, [key]: null },
    };
  }),
  on(loadDriverManagementDriversSuccess, (state, { key, response }) => ({
    ...state,
    cache: { ...state.cache, [key]: response },
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: null },
  })),
  on(loadDriverManagementDriversFailure, (state, { key, error }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: error },
  })),
  on(clearDriverManagementDriversByKey, (state, { key }) => {
    const cache = { ...state.cache };
    const loading = { ...state.loading };
    const error = { ...state.error };

    delete cache[key];
    delete loading[key];
    delete error[key];

    return {
      ...state,
      cache,
      loading,
      error,
    };
  }),
  on(clearDriverManagementDrivers, () => initialState),
);
